import type { JSX } from 'solid-js'

/**
 * O triangulo de atencao dos avisos de cobertura.
 *
 * Mora num arquivo so porque duas alturas da tela o desenham - a faixa defeituosa e o
 * indicador que a contem -, e um SVG copiado em dois lugares diverge no primeiro ajuste.
 */
export function WarningIcon(): JSX.Element {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <path
                d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M12 9v4M12 17h.01" stroke-linecap="round" />
        </svg>
    )
}
